import { css } from '@styled-system/css';
import { stack } from '@styled-system/patterns';
import Skeleton from 'react-loading-skeleton';

import { Separator } from '@/shared/components/ui/Separator';

import 'react-loading-skeleton/dist/skeleton.css';

export const SubscriptionPlanCardSkeleton = () => {
  const cardContainerStyles = css({
    width: '19rem',
    height: '30rem',
    backgroundColor: 'base.segBg',
    border: '0.75px solid',
    borderColor: 'base.border',
    borderRadius: 'lg',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
  });

  const headerStyles = stack({
    direction: 'column',
    gap: 'xs',
    alignItems: 'left',
    mt: '1.69rem',
    mb: '0.25rem',
    px: '1.75rem',
  });

  const priceContainerStyles = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    gap: '0.25rem',
  });

  const featuresContainerStyles = stack({
    direction: 'column',
    gap: 'md',
    flex: 1,
    pl: '1.44rem',
    pr: '1.37rem',
  });

  const featureRowStyles = css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    h: '0.75rem',
  });

  const buttonContainerStyles = css({
    pb: '2.38rem',
    w: '15.1875rem',
    alignSelf: 'center',
  });

  return (
    <div className={cardContainerStyles}>
      {/* Header */}
      <div className={headerStyles}>
        {/* Plan name */}
        <Skeleton width="7rem" height="0.875rem" />

        {/* Price */}
        <div className={priceContainerStyles}>
          <Skeleton width="9rem" height="1.68rem" />
        </div>
      </div>

      <Separator />

      {/* Features */}
      <div className={featuresContainerStyles}>
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className={featureRowStyles}>
            <Skeleton width="10rem" height="0.75rem" />
            <Skeleton width="2.3rem" height="0.75rem" />
          </div>
        ))}
      </div>

      {/* Button */}
      <div className={buttonContainerStyles}>
        <Skeleton width="100%" height="2.125rem" borderRadius="0.375rem" />
      </div>
    </div>
  );
};
